<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 13 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.28087 20.5C1.96817 20.4997 1.66256 20.4068 1.40265 20.2329C1.14274 20.0591 0.940173 19.8121 0.820545 19.5232C0.700917 19.2343 0.66959 18.9164 0.730519 18.6097C0.791448 18.303 0.941902 18.0212 1.16288 17.7999L8.48044 10.4803L1.16288 3.16059C0.883421 2.86068 0.731282 2.46402 0.738514 2.05415C0.745745 1.64429 0.911783 1.25324 1.20164 0.963375C1.49151 0.673514 1.88256 0.507478 2.29242 0.500246C2.70228 0.493015 3.09895 0.645152 3.39886 0.924608L11.8365 9.36228C11.9835 9.50902 12.1001 9.68329 12.1796 9.87512C12.2591 10.067 12.3001 10.2726 12.3001 10.4803C12.3001 10.6879 12.2591 10.8936 12.1796 11.0854C12.1001 11.2772 11.9835 11.4515 11.8365 11.5983L3.39886 20.0359C3.25251 20.1834 3.07832 20.3004 2.88641 20.3801C2.69449 20.4597 2.48866 20.5005 2.28087 20.5Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconChevronRight',
};
</script>
